import React from "react";

import { Box } from "@mui/material";

interface AcronymProps {
  text: string;
  title?: string;
}

export const Acronym: React.FC<AcronymProps> = ({ text, title = "" }) => (
  <Box component="abbr" title={title}>
    {text}
  </Box>
);

export const AMP = () => <Acronym text="AMP" title="Anchored Multiplex" />;

export const CTDNA = () => (
  <Acronym text="ctDNA" title="Circulating tumor deoxyribonucleic acid" />
);

export const DNA = () => <Acronym text="DNA" title="Deoxyribonucleic acid" />;

export const GSP = () => <Acronym text="GSP" title="gene-specific primers" />;

export const LIMS = () => (
  <Acronym text="LIMS" title="laboratory information management system" />
);

export const NA = () => <Acronym text="N/A" title="Not Applicable" />;

export const NGS = () => (
  <Acronym text="NGS" title="next generation sequencing" />
);

export const PCR = () => (
  <Acronym text="PCR" title="polymerase chain reaction" />
);

export const RNA = () => <Acronym text="RNA" title="Ribonucleic acid" />;
